import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <Section data-id="element-116">
      <div className="max-w-3xl mx-auto bg-gradient-to-br from-navy-800 to-navy-900 border-2 border-gold-500/50 rounded-2xl md:rounded-3xl p-5 md:p-12 text-center relative overflow-hidden shadow-[0_0_50px_rgba(212,168,67,0.1)]" data-id="element-117">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-50 pointer-events-none" data-id="element-118"></div>

        <ShieldCheck className="w-12 h-12 md:w-20 md:h-20 text-gold-400 mx-auto mb-3 md:mb-6 relative z-10" data-id="element-119" />

        <h2 className="text-xl md:text-4xl font-black text-white mb-3 md:mb-6 relative z-10" data-id="element-120">
          ✨ GARANTÍA GIMNASIA ARTÍSTICA RESUELTA — 7 DÍAS ✨
        </h2>

        <div className="space-y-2 md:space-y-4 text-sm md:text-lg text-gray-300 relative z-10 mb-4 md:mb-8" data-id="element-121">
          <p data-id="element-122">Abrís los 6 tomos. Revisás los 6 bonos.</p>
          <p data-id="element-123">Los usás en tu clase si querés.</p>
          <p className="text-white font-bold text-base md:text-xl" data-id="element-124">
            Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
          </p>
          <p data-id="element-125">Sin preguntas. Sin formularios. Sin drama.</p>
        </div>

        <p className="text-gray-400 text-xs md:text-sm relative z-10 max-w-xl mx-auto mb-4 md:mb-6" data-id="element-126">
          La confianza que tenemos en Gimnasia Artística Resuelta™ nos permite
          hacer esa promesa sin dudar. Más de 300 profesores ya lo saben.
        </p>

        <div className="inline-block bg-navy-950 border border-navy-700 px-4 py-2 md:px-6 md:py-3 rounded-full relative z-10" data-id="element-127">
          <span className="text-gold-400 font-bold tracking-widest uppercase text-xs md:text-sm" data-id="element-128">
            TASA DE DEVOLUCIONES MENOR AL 1%
          </span>
        </div>
      </div>
    </Section>;
}